<script>
  export default {
    props: {
      inscricao: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        cadastroCompleto: this.inscricao.solicitacaoCursoEventoServico.turma.cadastroCompleto,
        pessoaFisica: !(this.inscricao.documento.length > 16)
      }
    },
  }
</script>

<template>
  <div>
    <div class="row">
      <dl class="col-xs-12">
        <dt>Nome</dt>
        <dd>
          {{ inscricao.nome }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl class="col-xs-9">
        <dt>Endereço</dt>
        <dd>
          {{ inscricao.endereco }}
        </dd>
      </dl>

      <dl class="col-xs-3">
        <dt>Número</dt>
        <dd>
          {{ inscricao.numero }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl class="col-xs-7">
        <dt>Complemento</dt>
        <dd>
          {{ inscricao.complemento }}
        </dd>
      </dl>

      <dl class="col-xs-5">
        <dt>Cidade</dt>
        <dd>
          {{ inscricao.cidade }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl class="col-xs-4">
        <dt>Telefone</dt>
        <dd>
          {{ inscricao.telefone }}
        </dd>
      </dl>

      <dl class="col-xs-4">
        <dt>Celular</dt>
        <dd>
          {{ inscricao.celular }}
        </dd>
      </dl>

      <dl class="col-xs-4">
        <dt>Data de nascimento</dt>
        <dd>
          {{ inscricao.dataNascimento }}
        </dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-xs-12">
        <dt>Email</dt>
        <dd>
          {{ inscricao.email }}
        </dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-xs-8" v-if="inscricao.faixaValores">
        <dt>Categoria de inscrição</dt>
        <dd>
          {{ inscricao.faixaValores }}
        </dd>
      </dl>

      <dl class="col-xs-8" v-if="!inscricao.faixaValores">
        <dt></dt>
        <dd></dd>
      </dl>

      <dl class="col-xs-3">
        <dt>Valor</dt>
        <dd>
          {{ inscricao.valor | formatarNumero }}
        </dd>
      </dl>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-matricular/componentes/compartilhado/FormDadosInscricaoEstrangeiro.vue